import { useState, useCallback } from 'react';
import { paymentService } from 'src/services/services/payment/payment.api';
import { CouponWithPromoCodes, Product } from 'src/interfaces/Payments';
import { ResponseKind } from 'src/services/services/MainService';

interface Price {
  product_id: string;
  product_name: string;
  prices: {
    price_id: string;
    unit_amount: number;
    currency: string;
    is_default_price: boolean;
    lookup_key: string;
    billing_interval: string;
    active: boolean;
  }[];
}

export const usePaymentManagement = () => {
  const [prices, setPrices] = useState<Price[]>([]);
  const [coupons, setCoupons] = useState<CouponWithPromoCodes["coupons"]>([]);
  const [products, setProducts] = useState<Product[]>([]);

  const fetchPrices = useCallback(async () => {
    const response = await paymentService.getProductsWithPrices();
    if(response.kind === ResponseKind.OK && response?.data?.products) {
      setPrices(response.data.products);
    }
  }, []);

  const fetchCoupons = useCallback(async () => {
    const response = await paymentService.getCouponsWithPromoCodes();
    if(response.kind === ResponseKind.OK && response?.data?.coupons) {
      setCoupons(response.data.coupons);
    }
  }, []);

  const fetchProducts = useCallback(async () => {
    const response = await paymentService.getProducts();
    if(response.kind === ResponseKind.OK && response?.data?.products) {
      setProducts(response.data.products);
    }
  }, []);

  // ... other payment management functions

  return {
    prices,
    setPrices,
    coupons,
    products,
    fetchPrices,
    fetchCoupons,
    fetchProducts,
  };
};